import { Box, Dialog, DialogContent, Grow, Typography } from '@mui/material';
import { keyframes } from '@mui/system';
import { memo, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckmarkIcon } from '~/assets/icons';

const Transition = forwardRef(function Transition(props: any, ref: any) {
  return <Grow ref={ref} {...props} timeout={400} />;
});

const popIn = keyframes`
  0% { transform: scale(0.5); opacity: 0; }
  70% { transform: scale(1.1); }
  100% { transform: scale(1); opacity: 1; }
`;

type ResolveSuccessModalProps = {
  open: boolean;
  onClose: () => void;
};

const ResolveSuccessModal = ({ open, onClose }: ResolveSuccessModalProps) => {
  const { t } = useTranslation('admin/alert');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      TransitionComponent={Transition}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
        },
      }}
      PaperProps={{
        sx: {
          width: '480px',
          height: '182px',
          borderRadius: '12px',
          background: '#FFFFFF',
          opacity: 1,
          boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.1)',
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
    >
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          padding: '20px 10px',
          gap: '20px',
        }}
      >
        <Box
          className='relative flex h-[80px] w-[80px] shrink-0 items-center justify-center rounded-full border-[5px] border-[#17A62B] bg-[#17A62B]'
          sx={{ animation: `${popIn} 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards` }}
        >
          <CheckmarkIcon
            className='h-auto w-[46px] [&_path]:stroke-[4.5px] [&_path]:stroke-white'
            style={{
              transform: 'translateY(5px)',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
          />
        </Box>

        <Typography
          sx={{
            fontFamily: '"Manrope", sans-serif',
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '140%',
            letterSpacing: '0.02em',
            color: '#161A1F',
            textAlign: 'center',
          }}
        >
          {t('alertDetail.resolveSuccess')}
        </Typography>
      </DialogContent>

    </Dialog>
  );
};

export default memo(ResolveSuccessModal);
